module.exports = __webpack_public_path__ + "static/media/layer5-box.dceeddee.png";